var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"live-warmup"},[_c('video',{ref:"myVideoWarmup",attrs:{"src":_vm.liveDetail.is_ad_url,"autoplay":"","controls":"","controlslist":"nodownload noplaybackrate nokeyboard nodownload","loop":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }